import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import ShareLink from './ShareLink';

const schema: JSONSchema7 = {
    title: 'ShareLink',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        link: {
            type: 'string',
            title: 'Link',
            description: 'URL for the link',
        },
        linkName: {
            type: 'string',
            title: 'Link Name',
            description: 'Link Name',
        },
        ariaLabel: {
            type: 'string',
            title: 'Aria Label',
        },
        iconName: {
            type: 'string',
            title: 'Icon Name',
            description: 'Icon Name',
        },
        toasterPosition: {
            type: 'string',
            title: 'Toaster Position',
            default: 'top-center',
        },
        showTooltip: {
            type: 'boolean',
            enum: [true, false],
            description: 'Show tooltip over link',
            default: false,
            title: 'Show tooltip',
        },
        fundUrlMapping: {
            type: 'array',
            title: 'Map to correct fund urls',
            items: {
                type: 'object',
                properties: {
                    parameters: {
                        type: 'array',
                        title: 'Parameters to match',
                        items: {
                            type: 'object',
                            required: ['key', 'value'],
                            properties: {
                                key: {
                                    type: 'string',
                                    title: 'Enter parameter key',
                                },
                                value: {
                                    type: 'string',
                                    title: 'Enter parameter value',
                                },
                            },
                        },
                    },
                    fundUrlTag: {
                        type: 'string',
                        title: 'Enter fund url tag from documents array',
                    },
                },
            },
        },
    },
    dependencies: {
        showTooltip: {
            oneOf: [
                {
                    properties: {
                        showTooltip: { enum: [true] },
                        toolTipText: {
                            type: 'string',
                            title: 'Tooltip text',
                            description: 'Text to show over tooltip',
                        },
                    },
                    required: ['toolTipText'],
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'link',
            'linkName',
            'ariaLabel',
            'iconName',
            'toasterPosition',
            'showTooltip',
            'toolTipText',
            'fundUrlMapping',
        ],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    link: {
        'ui:placeholder': 'https://',
    },
    styles: {
        'ui:widget': 'CSSEditor',
    },
};

const ShareLinkWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: ShareLink,
    id: 'ShareLink',
    group: 'button',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        linkName: 'Copy current URL',
        iconName: 'fas fa-share-square',
        showTooltip: false,
        toolTipText: '',
    }),
};

export default ShareLinkWidget;
